import React from 'react';
import { connect } from 'react-redux';
import { isDefined } from '../../../utils';
import StepAccomplished from '../../../icons/v3/BlueCheckBox';
import PopupCustomized from '../../PopupCustomized';

class UserProfilePresentationControl extends React.Component {
    constructor() {
        super();
        this.state = {
            showHelpPopup: false,
            mouseClickX: 100,
            mouseClickY: 100,
            jibeSessionIsDone: false,
            jibeSessionsCount: undefined,
            daysSinceLastJibeSession: undefined
        };

        this.showHelpPopup = this.showHelpPopup.bind(this);
        this.closeHelpPopup = this.closeHelpPopup.bind(this);
        this.postJibeSession = this.postJibeSession.bind(this);
    }

    componentDidMount() {
        const { jibeSessionsPast30DaysCount, daysSinceLastJibeSession } = this.props;
        this.setState({
            jibeSessionsCount: jibeSessionsPast30DaysCount,
            daysSinceLastJibeSession: daysSinceLastJibeSession
        });
    }

    postJibeSession() {
        this.setState({ jibeSessionIsDone: true });
        this.setState({
            jibeSessionsCount: this.state.jibeSessionsCount + 1,
            daysSinceLastJibeSession: 0
        })
        this.props.postJibeSession();
    }

    showHelpPopup(e) {
        this.setState({ showHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeHelpPopup() {
        this.setState({ showHelpPopup: false });
    }

    render() {
        const {
            title,
            stats,
            backgroundImage,
            showAgentInteractionsPopup,
            showSessionRequiredButton,
            isFullyJibed
        } = this.props;

        const viewInteractionsButton = (
            <div className="v3-button agent-view-interactions" style={{ marginRight: '10px' }} onClick={showAgentInteractionsPopup}>
                View Interactions
            </div>);

        var sessionRequiredButton;
        if (showSessionRequiredButton) {
            const enabledSessionRequiredButton = (
                <div className="v3-button session-required" onClick={this.postJibeSession}>
                    <label className="h3-semibold white-text cursor-pointer">Session Required</label>
                </div>);

            const disabledSessionRequiredButton = (
                <div className="v3-button session-required-disabled" style={{ cursor: 'auto' }} >
                    <label className="h3-semibold grey-text" >Session Completed</label>
                </div >);

            sessionRequiredButton = this.state.jibeSessionIsDone ? disabledSessionRequiredButton : enabledSessionRequiredButton;
        }

        return <div className="flex-item box-style"
            style={{ margin: '0', backgroundImage: `url(${`../../../../../Assets/Images/V3Design/${backgroundImage}.png`})` }}>

            {this.state.showHelpPopup &&
                <PopupCustomized x={this.state.mouseClickX} y={this.state.mouseClickY} Message={title} close={this.closeHelpPopup} />}

            <div className="flex-container" style={{ minHeight: '80px', marginTop: '20px', marginLeft: '184px' }}>
                <div style={{ flex: '1 1 401px' }}>
                    <div className="flex-container-justify-start-align-center" style={{ marginBottom: '16px' }}>
                        <p className="numbers-title" style={{ textAlign: 'start', marginBottom: '0', marginRight: '3px' }}>
                            {stats}
                        </p>
                        {isFullyJibed && <div style={{ backgroundImage: `url(${`../../../Assets/Images/V3Design/BlueBadgeWhite.png`})`, width: '40px', height: '38px' }} />}
                    </div>
                    <div className="flex-container-column-start">
                        {viewInteractionsButton}
                        {sessionRequiredButton}
                    </div>
                </div>
                <div style={{ marginRight: '58px' }}>
                    <div style={{ marginLeft: 'auto', marginTop: '5px' }}>
                        <div className="flex-container-justify-start-align-center" >
                            <p className="agent-top-panel-title">Jibe Sessions</p>
                            <p className="agent-top-panel-stats">{this.state.jibeSessionsCount}</p>
                        </div>
                    </div>
                    <div style={{ marginLeft: '13px', marginRight: '49px' }}>
                        {(isDefined(this.state.jibeSessionsCount) && this.state.jibeSessionsCount > 0) &&
                            <div className="flex-container" style={{ padding: '3px 0' }}>
                                <p className="agent-top-panel-title">Last Session</p>
                                <p className="agent-top-panel-stats">{this.state.daysSinceLastJibeSession}
                                    <span className="agent-top-panel-small-title">   days ago</span>
                                </p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    };
}

const select = state => ({ session: state.session });

export default connect(select)(UserProfilePresentationControl);
